import Info from './info';
import './info.scss';

export default Info;